
/*
 * Safira theme - local Add to Cart reliability fix
 * This handler is intentionally independent of the theme's external JS.
 * It intercepts product add-to-cart forms, submits them through Shopify's
 * Ajax Cart API, and refreshes the cart drawer/icon when available.
 */
(function () {
  'use strict';

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function setButtonState(button, loading) {
    if (!button) return;
    button.disabled = loading;
    button.classList.toggle('loading', loading);
    var spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
  }

  function showFormError(form, message) {
    var wrapper = form.closest('product-form') || form.parentElement;
    var errorWrapper = wrapper && wrapper.querySelector('.product-form__error-message-wrapper');
    var errorMessage = wrapper && wrapper.querySelector('.product-form__error-message');
    if (errorWrapper && errorMessage) {
      errorMessage.textContent = message || window.cartStrings?.error || 'Unable to add this item to the cart. Please try again.';
      errorWrapper.hidden = false;
    } else {
      alert(message || 'Unable to add this item to the cart. Please try again.');
    }
  }

  function clearFormError(form) {
    var wrapper = form.closest('product-form') || form.parentElement;
    var errorWrapper = wrapper && wrapper.querySelector('.product-form__error-message-wrapper');
    if (errorWrapper) errorWrapper.hidden = true;
  }

  function updateCartIcon(html) {
    if (!html) return;
    var current = document.getElementById('cart-icon-bubble');
    if (!current) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var replacement = parsed.querySelector('#cart-icon-bubble');
    if (replacement) current.replaceWith(replacement);
  }

  function updateCartDrawer(html, openDrawer) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var replacement = parsed.querySelector('cart-drawer');
    var current = getCartDrawer();

    if (replacement && current) {
      current.replaceWith(replacement);
      current = getCartDrawer();
    }

    if (openDrawer && current) {
      if (typeof current.open === 'function') {
        try { current.open(); return; } catch (e) {}
      }
      current.classList.remove('is-empty');
      current.classList.add('active');
      document.body.classList.add('overflow-hidden');
      var inner = current.querySelector('.drawer__inner');
      if (inner) inner.setAttribute('tabindex', '-1');
    }
  }

  function bindFallbackDrawerControls() {
    document.addEventListener('click', function (event) {
      var close = event.target.closest && event.target.closest('cart-drawer .drawer__close, cart-drawer .cart-drawer__overlay');
      if (!close) return;
      var drawer = getCartDrawer();
      if (!drawer) return;
      if (typeof drawer.close === 'function') {
        try { drawer.close(); return; } catch (e) {}
      }
      drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    });
  }

  async function addToCart(form, submitter) {
    clearFormError(form);
    setButtonState(submitter, true);

    var data = new FormData(form);
    if (!data.get('id')) {
      throw new Error('No product variant was selected.');
    }

    // Ask Shopify to return the cart drawer and cart icon sections in the same response.
    data.append('sections', 'cart-drawer,cart-icon-bubble');
    data.append('sections_url', window.location.pathname + window.location.search);

    var action = form.getAttribute('action') || (window.routes && window.routes.cart_add_url) || '/cart/add';
    action = action.replace(/\/$/, '');
    if (!/\.js$/i.test(action)) action += '.js';

    var response = await fetch(action, {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: data,
      credentials: 'same-origin'
    });

    var payload = {};
    try {
      payload = await response.json();
    } catch (e) {}

    if (!response.ok || payload.status) {
      var message = payload.description || payload.message || 'Unable to add this item to the cart.';
      throw new Error(message);
    }

    if (payload.sections) {
      updateCartIcon(payload.sections['cart-icon-bubble']);
      updateCartDrawer(payload.sections['cart-drawer'], !!getCartDrawer());
    } else {
      // Fallback: refresh the cart page if Shopify did not return section HTML.
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }

    // Respect a theme block configured to skip opening the cart.
    var skipCart = form.querySelector('[data-skip-cart="true"]');
    if (skipCart) {
      var drawer = getCartDrawer();
      if (drawer && typeof drawer.close === 'function') {
        try { drawer.close(); } catch (e) {}
      }
    }

    document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: payload }));
  }

  // Capture phase runs before the theme's other submit handlers. This makes the
  // cart work even if the theme's external product-form script is missing/broken.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[data-type="add-to-cart-form"]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var submitter = event.submitter || form.querySelector('button[name="add"], button[type="submit"]');
    if (submitter && submitter.disabled) return;

    addToCart(form, submitter).catch(function (error) {
      console.error('[Cart Fix]', error);
      showFormError(form, error.message);
    }).finally(function () {
      setButtonState(submitter, false);
    });
  }, true);

  bindFallbackDrawerControls();
})();
